
<div>
  <div class="marunageContent__container">
    <h2 class="marunageContent__title">コンシェルジュに会場探しをお願いする</h2>
    <div style="margin-top: 10px;">
      <a @click.prevent="openDialog" class="ui big form clickable">
        <input type="text" placeholder="エリア" style="width: 30%; margin-right: -6px;" readonly>
        <input type="text" placeholder="人数" style="width: 30%; margin-right: -6px;" readonly>
        <div class="ui action input" style="width: 30%;">
          <input type="text" placeholder="予算" readonly>
          <button class="ui icon yellow button">
            <i class="search large icon"></i>
          </button>
        </div>
      </a>
    </div>
  </div>
  <div class="marunageContent__tel">
    <div class="marunageContent__telHintContainer">
      <span class="marunageContent__telHintTop">お電話でのご相談はこちら</span>
      <span class="marunageContent__telHintBottom">24時間・年中無休</span>
    </div>
    <div class="marunageContent__telNoContainer">
      <i class="fas fa-phone-volume fa-3x marunageContent__telIcon" data-fa-transform="rotate-330"></i>
      <div class="marunageContent__telNoTextContainer">
        <span class="marunageContent__telNoName">宴会コンシェルジュデスク</span>
        <span class="marunageContent__telNo"><concierge-tel></concierge-tel></span>
      </div>
    </div>
  </div>

  <div id="marunage-link-dialog" class="ui small modal">
    <i class="close icon"></i>
    <div class="scrolling content">
      <detailed-marunage-form :action-label="'送信する'" :form-name-prefix="formNamePrefix"></detailed-marunage-form>
    </div>
  </div>
</div>
